module.exports = __webpack_public_path__ + "static/media/ntakirutimana_masaka4.82c44938.png";